'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.onMarkdownEditorKeyDown = exports.validateTargetDiv = exports.isTargetDiv = undefined;

var _convertCtrlKey = require('@dhis2/d2-ui-rich-text/editor/convertCtrlKey');

var _convertCtrlKey2 = _interopRequireDefault(_convertCtrlKey);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var isTargetDiv = exports.isTargetDiv = function isTargetDiv(elementId) {
    return !!document.getElementById(elementId);
};

var validateTargetDiv = exports.validateTargetDiv = function validateTargetDiv(elementId, msg) {
    if (!isTargetDiv(elementId)) {
        if (msg) {
            console.log(msg);
        }

        return false;
    }

    return true;
};

var onMarkdownEditorKeyDown = exports.onMarkdownEditorKeyDown = function onMarkdownEditorKeyDown(f, e) {
    (0, _convertCtrlKey2.default)(e.browserEvent, function (newValue, newCursorPos) {
        var textarea = e.target;
        textarea.value = newValue;
        textarea.setSelectionRange(newCursorPos, newCursorPos);
    });
};
//# sourceMappingURL=dom.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/d2-analysis/lib/util/dom.js
 ** module id = 32
 ** module chunks = 0 1
 **/